module.exports = {"id":"175896","name":"Sébastien Siani","rating":"73","photo":"./data/images/photos/4/175896.png","club":{"name":"Antwerp","logo":"./data/images/clubs/Antwerp.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SebastienSiani0.json
// module id = 3881
// module chunks = 0